<style scoped>
.card-title {
  font-size: 1.5rem;
  font-weight: bold;
  display: flex;
  justify-content: space-between;
}
.card-text {
  margin-bottom: 1rem;
}
.v-card {
  margin: 0 auto;
  min-width: 90vw; 
  max-width: 90vw;
}
.v-tabs {
  margin-bottom: 1rem;
  min-height: 2%;
}
.v-tabs .v-tab {
  cursor: pointer;
}
.table-cell {
  padding: 1rem;
  min-width: 100%;
  border-bottom: 1px solid #ccc;
}
.table-cell:first-child {
  font-weight: bold;
  color:#154985;
  min-width: 200px;
}
.scrollable-table-body {
  overflow-y: auto; 
  max-height: 61vh;
  margin-top: 0; 
}
</style>

<template>
  <v-card text style="overflow:hidden;">
    
    <v-card-title class="card-title">
      <p style="width: 50%; color:#154985">{{ incomingProject.Projet }}</p>
      <v-btn @click="$emit('close')">
      <v-icon>mdi-close</v-icon> <!-- Ajoutez l'icône de fermeture -->
    </v-btn>
    </v-card-title>
    <v-card-text class="card-text">{{ incomingProject["Résumé"] }}</v-card-text>
    <v-tabs v-model="displayMode" color="#154985">
      <v-tab value="general">Général</v-tab>
      <v-tab value="BudgetPartenaires">Budget et Partenaires</v-tab>
      <v-tab value="CaptageCO2">Captage de CO2</v-tab>
      <v-tab value="PerspectivesRésultats">Perspectives et résultats</v-tab>
    </v-tabs>
    <v-simple-table class="scrollable-table-body">
      <template v-slot:default>
        <tbody >
          <tr v-for="item in datasheet" :key="item.key">
            <td class="table-cell">{{ item.key }}</td>
            <td class="table-cell">
              <template v-if="['Partenaires','Budget /part nette avec financement','Budget /part hors financement','Activités'].includes(item.key)">
                <ul class="chip-list">
                  <v-chip style="margin-bottom: 12px;" label class="mr-2" size="default" variant="elevated" color="#86B404"  v-for="partenaire in item.value.split('-').slice(1)" :key="partenaire">{{ partenaire }}</v-chip>
                </ul>
              </template>
              <template v-else-if="['Type de projet','Mode de Captage','Utilisation: Conversion','Stockage','Transports'].includes(item.key)">
                <v-chip style="margin-bottom: 12px;" label class="mr-2" size="default" variant="elevated" color="#86B404" v-if="item.value" v-for="val in item.value.split(';#')">{{ val }}</v-chip>
              </template>
              <template v-else-if="item.key === 'Type de projet'">
                <v-chip  v-for="type in item.value" :key="type">{{ type }}</v-chip>
              </template>
              <template v-else>
                {{ item.value }}
              </template>
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
  </v-card>
</template>

<script>
import { object2Array } from "../../../helpers";

let configHeadersByCategories = {
  general: ["Projet", "Type de projet", "Descriptif", "Situation géographique", "Date de départ", "Date de FIN", "Porteur(s) du projet", "statut"],
  BudgetPartenaires: ["Bugdet", "Partenaires", "Budget /part nette avec financement", "Budget /part hors financement", "Source de financement"],
  CaptageCo2: ["Activités", "Source du CO2", "Catégories de Produits", "catégories de la technologie", "Mode de Captage", "Produit(s) spécifique(s)", "Volume de CO2 capté", "Volume de production", "Tonne de CO2 évitée", "Utilisation: Conversion", "Stockage", "Transports", "Capture/Utilisation du CO2"],
  RésultatEtPerspectives: ["Action de chaque acteurs", "TRL de départ", "TRL de fin", "Perspectives", "Résultas", "Website"],
};

export default {
  props: ['incomingProject'],
  data: () => ({
    displayMode: "general",
    headersByCategories: configHeadersByCategories
  }),
  computed: {
    datasheet() {
      let headers = "general";
      switch (this.displayMode) {
        case "BudgetPartenaires":
          headers = "BudgetPartenaires";
          break;
        case "CaptageCO2":
          headers = "CaptageCo2";
          break;
        case "PerspectivesRésultats":
          headers = "RésultatEtPerspectives";
          break;
        default:
          headers = "general"
      }
      return object2Array(this.incomingProject, this.headersByCategories[headers])
    }
  },
}
</script>
